import {WelcomeScreen} from './WelcomeScreen';
import {useKioskoStore} from 'context/kiosko/useKioskoStore';
import {useLayoutMode} from 'hooks/useLayoutMode';
import {ViewLoader} from 'pages/Auth/components/ViewLoader';

export const WelcomeScreenWrapper = () => {
  const {
    connection: {isInitializing, hasCompletedInitialization, isConnected},
  } = useKioskoStore();
  const layoutMode = useLayoutMode();

  const shouldShowLoader =
    layoutMode === 'kiosko' &&
    isInitializing &&
    !hasCompletedInitialization &&
    (isConnected || isInitializing);

  if (shouldShowLoader) {
    return <ViewLoader />;
  }

  return <WelcomeScreen />;
};
